import { alpha, ListItemText, MenuItem, styled } from '@mui/material';
import { common, grey } from '@mui/material/colors';

export const SnapshotRowRoot = styled(MenuItem)({
  flexDirection: 'column',
});

export const SnapshotContent = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '3rem',
});

export const SnapshotPreview = styled('div')({
  marginRight: '0.5rem',
  width: '2.5rem',
  height: '2.5rem',
  border: `0.1rem solid ${alpha(common.black, 0.12)}`,
  background: grey[100],
  '& img': {
    width: '100%',
    height: '100%',
  },
});

export const SnapshotTitle = styled(ListItemText)({
  flexGrow: 1,
});

export const SnapshotActions = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
});

export const SnapshotCaption = styled('div')({
  color: grey[500],
});
